const simpleParallax = require('../vendor/image-parallax');

let parallax = {
    init: () => {
        if ($(window).width() >= 992) {

            // direction options
            var downImage = document.getElementsByClassName('img-parallax-down');
            new simpleParallax(downImage, {
                delay: 1,
                transition: 'cubic-bezier(0,0,0,1)',
                overflow: true,
                orientation: 'down',
                scale: 0.5,
                maxTransition: 80,
            });
        }
    }
}
$(document).ready(() => {
    parallax.init();
});

$(window).resize(() => {
    parallax.init();
});